export const DecedentContent = {
  pageTitle: `Provide some information about the person who passed away`,
  pageTitleProspect: `Next, provide some information about the person who passed away`,
  pageTitleMultiInheritance: `To begin, provide some information about the person who passed away`,
  subtitle: `Enter the decedent’s name exactly as it appears on their Vanguard account or a Vanguard statement`,
  continueButton: `Continue`,
  inputErrorMsg: `Your entry is invalid.`,
  matchErrorMsg: `It looks like you're logged on to the Vanguard account for the person who passed away. If you'd like to complete the transfer, please log off and then log on with your own user name and password. If you don't have your own user name and password, please sign up for web access to complete the transfer.`,
  logOff: `Log off of this account`,
  logOffLink: `/us/LogonLogoff`,
  loadingSpinner: `Loading...`,
  reviewModal: {
    title: 'Review what you’ve entered so far',
    desc: 'Please take a moment and make sure all the personal information you’ve entered is correct.',
    button: 'OK',
  },
  formContent: {
    firstName: {
      placeHolder: 'First name',
      requiredErrorMessage: 'This field is required.',
      invalidErrorMessage: 'Your entry is invalid.',
    },
    middleName: {
      placeHolder: 'MI',
      requiredErrorMessage: 'This field is required.',
      invalidErrorMessage: 'Your entry is invalid.',
    },
    lastName: {
      placeHolder: 'Last name',
      requiredErrorMessage: 'This field is required.',
      invalidErrorMessage: 'Your entry is invalid.',
    },
    decedentId: {
      placeHolder: 'Social Security number',
      requiredErrorMessage: 'This field is required.',
      invalidSSNLength: 'Enter the full 9 digit SSN number to continue.',
      invalidErrorMessage: 'Your entry is invalid.',
    },
    zipCode: {
      placeHolder: 'Zip code',
      requiredErrorMessage: 'This field is required.',
      invalidErrorMessage: 'Your entry is invalid.',
    },
    dateOfBirth: {
      placeHolder: 'Date of birth (mm/dd/yyyy)',
      requiredErrorMessage: 'This field is required.',
      invalidErrorMessage: 'Your entry is invalid.',
    },
    dateOfDeath: {
      placeHolder: 'Date of death (mm/dd/yyyy)',
      requiredErrorMessage: 'This field is required.',
      invalidErrorMessage: 'Your entry is invalid.',
    },
    isDOBBeforeDOD: {
      errorMessage: 'The date of death cannot be before the date of birth.',
    },
  },
};
